"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.distinct = void 0;
function distinct(input) {
    return input.filter(function (value, index, array) { return array.indexOf(value) === index; });
}
exports.distinct = distinct;
